import { useState } from 'react'
import './ActivityForm.css'

const ActivityForm = ({ type, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    subject: '',
    description: '',
    duration: '',
    location: ''
  })
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      await onSubmit(formData)
    } catch (error) {
      console.error('Error submitting activity:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const getActivityTitle = () => {
    switch (type) {
      case 'email':
        return 'Log Email'
      case 'call':
        return 'Log Call'
      case 'meeting':
        return 'Log Meeting'
      case 'website_visit':
        return 'Log Website Visit'
      case 'linkedin_message':
        return 'Log LinkedIn Message'
      default:
        return 'Log Activity'
    }
  }

  return (
    <div className="form-overlay">
      <div className="form-modal">
        <div className="form-header">
          <h3>{getActivityTitle()}</h3>
          <button className="close-btn" onClick={onCancel}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder={type === 'email' ? 'Email subject' : type === 'call' ? 'Call topic' : type === 'linkedin_message' ? 'Message subject' : 'Activity subject'}
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="4"
              placeholder="Add details about this activity..."
            />
          </div>

          {(type === 'call' || type === 'meeting') && (
            <div className="form-group">
              <label htmlFor="duration">Duration</label>
              <input
                type="text"
                id="duration"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                placeholder="e.g., 30 minutes, 1 hour"
              />
            </div>
          )}

          {type === 'meeting' && (
            <div className="form-group">
              <label htmlFor="location">Location</label>
              <input
                type="text"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Meeting location or video link"
              />
            </div>
          )}

          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Logging...' : 'Log Activity'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ActivityForm

